import { AlertSendHistoryApiModel } from '@api/briefings/model/alert-send-history-api.model';

export class AlertHistoryModel {
    alertName: string;
    briefingSentId: number;
    briefingId: number;
    metric: string;
    submittedDate: string;
    surgePercentageChangeNegative: number;
    surgePercentageChangePositive: number;
    createdByUserId: number;
    impactfulDataChangeSinceSent: boolean;
    guid: string;

    constructor(apiModel?: AlertSendHistoryApiModel) {
        if (apiModel) {
            this.alertName = apiModel.alertName;
            this.briefingSentId = apiModel.briefingSentId;
            this.briefingId = apiModel.briefingId;
            this.metric = apiModel.metric;
            this.submittedDate = apiModel.submittedDate;
            this.surgePercentageChangeNegative = apiModel.surgePercentageChangeNegative;
            this.surgePercentageChangePositive = apiModel.surgePercentageChangePositive;
            this.createdByUserId = apiModel.createdByUserId;
            this.impactfulDataChangeSinceSent = apiModel.impactfulDataChangeSinceSent;
            this.guid = apiModel.guid;
        }
    }
}
